import { Injectable } from '@angular/core';
import { HttpClient,HttpRequest,HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import { User } from '../_models/user';

@Injectable({ providedIn: 'root' })
export class AstrolyticsService {


    public currentUser: Observable<any>;
    //private apiUrl = "http://api.astrolytics.info/api";
    private apiUrl = "https://api.astrolytics.info/api";
    //private apiUrl = "http://localhost:5000/api";

    private categoriesSubject: BehaviorSubject<any>;
    public categoriesObservable: Observable<any>;

    private leafCategoriesSubject: BehaviorSubject<any>;
    public leafCategoriesObservable: Observable<any>;

    private monthlySalesSubject: BehaviorSubject<any>;
    public monthlySalesObservable: Observable<any>;

    private userFavoritesSubject: BehaviorSubject<any>;
    public userFavoritesObservable: Observable<any>;

    private errorSubject: BehaviorSubject<any>;
    public errorObservable: Observable<any>;

    private sellerDataSubject: BehaviorSubject<any>;
    public sellerDataObservable: Observable<any>;

    private trendsSubject: BehaviorSubject<any>;
    public trendsObservable: Observable<any>;

    private storeDataSubject: BehaviorSubject<any>;
    public storeDataObservable: Observable<any>

    private userStoreDataSubject: BehaviorSubject<any>;
    public userStoreDataObservable: Observable<any>

    private userStoreStatisticsSubject: BehaviorSubject<any>;
    public userStoreStatisticsObservable: Observable<any>

    private storeStatisticsSubject: BehaviorSubject<any>;
    public storeStatisticsObservable: Observable<any>

    private sellerRankingSubject: BehaviorSubject<any>;
    public sellerRankingObservable: Observable<any>

    private sellerSearchSubject: BehaviorSubject<any>;
    public sellerSearchObservable: Observable<any>;

    private listingsSearchSubject: BehaviorSubject<any>;
    public listingsSearchObservable: Observable<any>;

    private dashboardGraphSubject: BehaviorSubject<any>;
    public dashboardGraphObservable: Observable<any>;

    private dashboardGraphStoreSubject: BehaviorSubject<any>;
    public dashboardGraphStoreObservable: Observable<any>;

    private recommendationSubject: BehaviorSubject<any>;
    public recommendationObservable: Observable<any>;

    constructor(private http: HttpClient) {
        this.categoriesSubject = new BehaviorSubject<any>("");
        this.categoriesObservable = this.categoriesSubject.asObservable();

        this.leafCategoriesSubject = new BehaviorSubject<any>("");
        this.leafCategoriesObservable = this.leafCategoriesSubject.asObservable();

        this.monthlySalesSubject = new BehaviorSubject<any>("");
        this.monthlySalesObservable = this.monthlySalesSubject.asObservable();

        this.userFavoritesSubject = new BehaviorSubject<any>("");
        this.userFavoritesObservable = this.userFavoritesSubject.asObservable();

        this.errorSubject = new BehaviorSubject<any>("");
        this.errorObservable = this.errorSubject.asObservable();

        this.sellerDataSubject = new BehaviorSubject<any>("");
        this.sellerDataObservable = this.sellerDataSubject.asObservable();

        this.trendsSubject = new BehaviorSubject<any>("");
        this.trendsObservable = this.trendsSubject.asObservable();

        this.storeDataSubject = new BehaviorSubject<any>("");
        this.storeDataObservable = this.storeDataSubject.asObservable();

        this.storeStatisticsSubject = new BehaviorSubject<any>("");
        this.storeStatisticsObservable = this.storeStatisticsSubject.asObservable();

        this.userStoreDataSubject = new BehaviorSubject<any>("");
        this.userStoreDataObservable = this.userStoreDataSubject.asObservable();

        this.userStoreStatisticsSubject = new BehaviorSubject<any>("");
        this.userStoreStatisticsObservable = this.userStoreStatisticsSubject.asObservable();

        this.sellerSearchSubject = new BehaviorSubject<any>("");
        this.sellerSearchObservable = this.sellerSearchSubject.asObservable();

        this.listingsSearchSubject = new BehaviorSubject<any>("");
        this.listingsSearchObservable = this.listingsSearchSubject.asObservable();

        this.sellerRankingSubject = new BehaviorSubject<any>("");
        this.sellerRankingObservable = this.sellerRankingSubject.asObservable();

        this.dashboardGraphSubject = new BehaviorSubject<any>("");
        this.dashboardGraphObservable = this.dashboardGraphSubject.asObservable();

        this.dashboardGraphStoreSubject = new BehaviorSubject<any>("");
        this.dashboardGraphStoreObservable = this.dashboardGraphStoreSubject.asObservable();

        this.recommendationSubject = new BehaviorSubject<any>("");
        this.recommendationObservable = this.recommendationSubject.asObservable();
    }

    getDashboardGraphs(user_id){
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(this.apiUrl+"/user/"+user_id+"/favorites/items").subscribe(
            (response) => {
                this.dashboardGraphSubject.next(response);
            },
            (error) =>{
                console.log(error);
            }
        );
    }

    getDashboardStoreGraphs(user_id){
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(this.apiUrl+"/user/"+user_id+"/favorites/stores").subscribe(
            (response) => {
                this.dashboardGraphStoreSubject.next(response);
            },
            (error) =>{
                console.log(error);
            }
        );
    }

    getCategoryData(meli_id){
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(this.apiUrl+"/categories/data/"+meli_id).subscribe(
            (response) => {
                this.categoriesSubject.next(response);
            },
            (error) =>{
                console.log(error);
            }
        );
    }


    getTrends(meli_id){
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(this.apiUrl+"/trends/"+meli_id).subscribe(
            (response) => {
                this.trendsSubject.next(response);
            },
            (error) =>{
                console.log(error);
            }
        );
    }

    getSellerData(seller_id){
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(this.apiUrl+"/seller/statistics/"+seller_id).subscribe(
            (response) => {
                this.sellerDataSubject.next(response);
            },
            (error) =>{
                console.log(error);
                this.sellerDataSubject.next(null)
            }
        );
    }

    getCategoryStatistics(meli_id) {
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(this.apiUrl+"/categories/statistics/"+meli_id).subscribe(
            (response) => {
                console.log(response)
                this.leafCategoriesSubject.next(response);
            },
            (error) =>{
                console.log(error);
            }
        );
    }

    getMonthlySales(storeId) {
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(this.apiUrl+`/stores/${storeId}/monthly_sales`).subscribe(
            (response) => {
                this.monthlySalesSubject.next(response);
            },
            (error) =>{
                console.log(error);
                this.errorSubject.next(error);
            }
        );
    }

    updateUserFavorites(userFavorites, userId){
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.put(this.apiUrl+`/user/${userId}/favorites`, userFavorites).subscribe(
            (response) => {
                console.log(`User favorites updated`);
            },
            (error) =>{
                console.log(error);
            }
        );
    }

    getUserFavorites(userId) {
            let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
            this.http.get(this.apiUrl+`/user/${userId}/favorites`, {}).subscribe(
                (response) => {
                    this.userFavoritesSubject.next(response);
                },
                (error) =>{
                    console.log(error);
                },
                () => console.log("OMG")
            );
    }

    downloadExcel(categoryStatistics){
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/ms-excel" });
        return this.http.post(this.apiUrl+`/categories/download-excel`, categoryStatistics, {
            responseType: 'arraybuffer',headers:headersConf} ).subscribe(response => {
                let dataType = "application/ms-excel";
                let filename = "Informe_Categoria.xlsx"
                let binaryData = [];
                binaryData.push(response);
                let downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
                if (filename)
                    downloadLink.setAttribute('download', filename);
                document.body.appendChild(downloadLink);
                downloadLink.click();
        })
    }

    downloadSellerExcel(sellerStatistics) {
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/ms-excel" });
        return this.http.post(this.apiUrl+`/sellers/download-excel`, sellerStatistics, {
            responseType: 'arraybuffer',headers:headersConf} ).subscribe(response => {
                let dataType = "application/ms-excel";
                let filename = "Informe_Vendedor.xlsx"
                let binaryData = [];
                binaryData.push(response);
                let downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
                if (filename)
                    downloadLink.setAttribute('download', filename);
                document.body.appendChild(downloadLink);
                downloadLink.click();
        })
    }

    getSellerMeliData(sellerId){
        return this.http.get(`${this.apiUrl}/sellers/${sellerId}/data`)
    }

    getSellerStatistics(sellerId){
        return this.http.get(`${this.apiUrl}/seller/statistics/${sellerId}`)
    }

    searchSellers(searchQuery){
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(`${this.apiUrl}/stores/search?q=${searchQuery}`).subscribe(
            (response) => {
                this.sellerSearchSubject.next(response);
            }
        );
    }

    searchListings(searchQuery,page = 1){
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(`${this.apiUrl}/listings/search?q=${searchQuery}&page=${page}`).subscribe(
            (response) => {
                this.listingsSearchSubject.next(response);
            }
        );
    }

    getSellerRankingData() {
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(`${this.apiUrl}/seller-ranking`).subscribe(
            (response) => {
                this.sellerRankingSubject.next(response);
            },
            (error) =>{
                console.log(error);
            }
        );
    }

    getStoreMeliId(astroId) {
        return this.http.get(`${this.apiUrl}/user/me/stores/${astroId}/meli-id`)
    }

    getStoreRecommendations(store_name) {
        let headersConf = new HttpHeaders({ 'Content-Type': 'application/json', "Accept": "application/json" });
        this.http.get(`${this.apiUrl}/sellers/`+store_name+"/recommendations").subscribe(
            (response) => {
                this.recommendationSubject.next(response);
            },
            (error) =>{
                console.log(error);
            }
        );
    }

    sendFeedback(feedback) {
        this.http.post(`${this.apiUrl}/feedback`, feedback).subscribe(
            (response) => {
                console.log("Feedback sent")
            },
            (error) => {
                console.log(error)
            }
        )
    }

    deleteUserFavData(userId, meliId) {
        this.http.delete(`${this.apiUrl}/user/${userId}/favorite-data/${meliId}`).subscribe(
            (response) => {
                console.log("Favorite data deleted");
            },
            (error) => {
                console.log(error);
            }
        )
    }


    createUserFavData(userId, meliId) {
        this.http.post(`${this.apiUrl}/user/${userId}/favorite-data/${meliId}`, {}).subscribe(
            (response) => {
                console.log("Favorite data created");
            },
            (error) => {
                console.log(error);
            }
        )
    }

}